import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

const STATUS_LABEL = {
  SUED: "เฮียสั่งฟ้อง",
};

const parseAccountNumbers = (raw) => {
  if (Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw ?? "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const formatPhones = (phones = []) =>
  phones
    .map((p) => `${p.party_locaion_usage ?? "-"}: ${p.telephone_num ?? "-"}`)
    .join("\n");

export async function exportLawyerExcel(data = []) {
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet("รายงานสัญญาที่ส่งทนาย");

  ws.columns = [
    { header: "ลำดับ", key: "no", width: 8 },
    { header: "รหัสลูกหนี้", key: "borrCode", width: 18 },
    { header: "ชื่อ-นามสกุล", key: "name", width: 30 },
    { header: "สถานะคดี", key: "status", width: 18 },
    { header: "ทนายที่รับผิดชอบ", key: "lawyerName", width: 22 },
    { header: "เงินต้น", key: "principle", width: 16 },
    { header: "ดอกเบี้ย SCB", key: "interest", width: 16 },
    { header: "เลขบัญชี", key: "accounts", width: 26 },
    { header: "เบอร์โทรศัพท์", key: "phones", width: 32 },
  ];

  data.forEach((r, i) => {
    const excelRow = ws.addRow({
      no: i + 1,
      borrCode: r.borr_code || "-",
      name: r.name || r.account_name || "-",
      status: STATUS_LABEL[r.lawsuit_status] || r.lawsuit_status || "-",
      lawyerName: r.lawyer_name || "-",
      principle: Number(r.principle_amount || 0),
      interest: Number(r.total_interest_amount || 0),
      accounts: parseAccountNumbers(r.account_numbers).join(", "),
      phones: formatPhones(r.phone) || "-",
    });

    excelRow.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    excelRow.getCell("principle").numFmt = "#,##0.00";
    excelRow.getCell("interest").numFmt = "#,##0.00";
  });

  const header = ws.getRow(1);
  header.height = 20;
  header.eachCell((cell) => {
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEFEFEF" },
    };
    cell.border = {
      top: { style: "medium" },
      left: { style: "thin" },
      bottom: { style: "medium" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `รายงานสัญญาที่ส่งทนาย_${dayjs().format("DD_MM_YY")}.xlsx`);
}
